import React, { useEffect, useContext, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom';
import ImageGallery from '../components/layout/ImageGallery';
import RelatedCard from '../components/RelatedCard';
import ProductContext from '../context/products/ProductContext'
import Spinner from '../components/layout/Spinner'
import ProductNotFound from '../components/layout/ProductNotFound';
import { Helmet } from 'react-helmet';
import { trackAddToCart } from '../utils/pixel.jsx';

function FuelFilter() {
    const { filter,
        loading,
        relatedProducts,
        fetchFilter,
        fetchRelatedProducts,
        addToCart,
        carName,
        getCarName } = useContext(ProductContext)

    const [quantity, setQuantity] = useState(filter.stock <= 0 ? 0 : 1);
    const initialStock = filter.stock && !isNaN(filter.stock) ? filter.stock : 0;

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const desc = decodeURIComponent(queryParams.get('desc'));

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const engineId = queryParams.get('ceng');
        if (engineId) {
            getCarName(engineId)
        }
    }, [])

    const { id } = useParams();
    useEffect(() => {
        if (id) {
            fetchFilter(id);
            fetchRelatedProducts();
        }
    }, [id]);

    const handleInput = (e) => {
        let value = parseInt(e.target.value);

        if (isNaN(value) || value <= 0) {
            value = 1;
        }

        if (value > initialStock) {
            value = initialStock;
        }

        setQuantity(value);
    };

    const handleButtonClick = (action) => {
        setQuantity((prevQuantity) => {
            if (action === 'increment' && prevQuantity < filter.stock) {
                return prevQuantity + 1;
            } else if (action === 'decrement' && prevQuantity > 1) {
                return prevQuantity - 1;
            }
            return prevQuantity;
        });
    };

    const pageTitle = `${filter.title} - Филтер за гориво за автомобил`;
    const pageDescription = `Погледнете детали за филтерот за гориво: ${filter.title}. Цената е ${filter.price} ден. Прегледајте го описот и карактеристиките на филтерот.`;
    const pageKeywords = `филтер за гориво, авто филтер, филтри за автомобили, филтри за гориво за автомобил, ${filter.manufacturer}, ${filter.filterType}`;

    if (loading) {
        return <Spinner />;
    }

    if (!filter && !loading) {
        return <ProductNotFound />
    }

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta name="keywords" content={pageKeywords} />
            </Helmet>

            {filter.id && !loading && (<div className="container mx-auto p-4">
                <h1 className="text-3xl font-bold mb-4">{filter.title}</h1>
                <div className="flex flex-col md:flex-row gap-6">
                    <div className="md:w-1/3">
                        {filter && Object.keys(filter).length > 0 && (
                            <ImageGallery key={filter.id} item={filter} />
                        )}
                    </div>
                    <div className='flex-1'>
                        <div className="overflow-x-auto">
                            <table className="table">
                                {/* head */}
                                <thead>
                                    <tr>
                                        <th>Опис на производот</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filter.filterType && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Тип на филтер</td>
                                        <td>{filter.filterType}</td>
                                    </tr>)}

                                    {filter.fuelType && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Тип на гориво</td>
                                        <td>{filter.fuelType}</td>
                                    </tr>)}

                                    {filter.height && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Висина  [mm]</td>
                                        <td>{filter.height}</td>
                                    </tr>)}

                                    {filter.diameter && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Дијаметар  [mm]</td>
                                        <td>{filter.diameter}</td>
                                    </tr>)}

                                    {filter.diameter1 && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Дијаметар [mm] 2</td>
                                        <td>{filter.diameter1}</td>
                                    </tr>)}

                                    {filter.innerDiameter && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Внатрешен Дијаметар  [mm]</td>
                                        <td>{filter.innerDiameter}</td>
                                    </tr>)}

                                    {filter.innerDiameter2 && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Внатрешен Дијаметар [mm] 2</td>
                                        <td>{filter.innerDiameter2}</td>
                                    </tr>)}

                                    {filter.inletMM && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Влез Ø [mm]</td>
                                        <td>{filter.inletMM}</td>
                                    </tr>)}

                                    {filter.outletMM && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Излез Ø [mm]</td>
                                        <td>{filter.outletMM}</td>
                                    </tr>)}

                                    {filter.manufacturer && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Производител</td>
                                        <td>{filter.manufacturer}</td>
                                    </tr>)}

                                    {filter.itemNumber && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>Број на филтер</td>
                                        <td>{filter.itemNumber}</td>
                                    </tr>)}

                                    {filter.eanNumber && (<tr className="odd:bg-white even:bg-gray-200">
                                        <td>EAN број</td>
                                        <td>{filter.eanNumber}</td>
                                    </tr>)}

                                </tbody>
                            </table>
                            {desc != 'null' && (<p className="text-myOrange mt-2 mb-3">*{desc}</p>)}
                            <p className="text-2xl text-red-600 font-semibold mb-4">{filter.price} ден</p>
                            <div className="flex items-center space-x-4">
                                <div className="py-2 px-3 inline-block bg-white border border-gray-200 rounded-lg dark:bg-neutral-900 dark:border-neutral-700">
                                    <div className="flex items-center gap-x-1.5">
                                        <button
                                            type="button"
                                            className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                            tabIndex="-1"
                                            aria-label="Decrease"
                                            onClick={() => handleButtonClick('decrement')}
                                            disabled={filter.stock == 0}
                                        >
                                            <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M5 12h14"></path>
                                            </svg>
                                        </button>
                                        <input
                                            id="quantity"
                                            type="number"
                                            className="p-0 w-8 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                                            style={{
                                                MozAppearance: 'textfield',
                                                WebkitAppearance: 'none',
                                            }}
                                            value={quantity}
                                            onInput={handleInput}
                                            min={1}
                                            max={filter.stock}
                                            disabled={filter.stock == 0}
                                        />
                                        <button
                                            type="button"
                                            className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                            tabIndex="-1"
                                            aria-label="Increase"
                                            onClick={() => handleButtonClick('increment')}
                                            disabled={filter.stock == 0}
                                        >
                                            <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M5 12h14"></path>
                                                <path d="M12 5v14"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <button className="btn btn-secondary btn-sm" disabled={filter.stock <= 0} onClick={() => {addToCart(filter, quantity, carName); trackAddToCart(filter.title, filter.price)}}>{filter.stock <= 0 ? (<span>Нема залиха</span>) : (<span>Додади во кошничка</span>)}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        {desc != 'null' && (
                            <ul className="list-inside mb-4 text-sm space-y-2">
                                <li>*<span className='font-bold text-l'>Број на шасија (VIN)</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>E</span></li>
                                <li>*<span className='font-bold text-l'>Број на мотор</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>P.5</span></li>
                                <li>*<span className='font-bold text-l'>Код на мотор</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>21</span></li>
                                <li>*<span className='font-bold text-l'>Година на производство</span> можете да најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>5А</span></li>
                            </ul>
                        )}
                    </div>
                </div>
                <div>
                    <h2 className='text-2xl font-bold mt-[10%] text-center mb-10'>Поврзани производи</h2>
                    <div
                        className='flex flex-wrap gap-12 justify-center'
                    >
                        {!relatedProducts || relatedProducts.length === 0 ? (
                            <p>Нема поврзани производи за прикажување</p>
                        ) : relatedProducts.map((prod) => (
                            <div key={prod.id}>
                                <RelatedCard key={prod.id} item={prod} />
                            </div>
                        ))
                        }
                    </div>
                </div>
            </div>)}
        </>
    )
}

export default FuelFilter
